import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import { NetworkHelperService } from '../../../_services/network-helper.service';
import {FORMS, API, CODFUNC, GENERALES, PAGE} from '../../../_config/strings';
import {Usuario} from '../../../_model/Usuario';
import { Cliente } from '../../../_model/Cliente';
import Swal from 'sweetalert2';
import {Subject} from 'rxjs/Subject';
import { IMyDpOptions, MyDatePicker, MyDatePickerModule } from 'mydatepicker';
import * as moment from 'moment';
import { ChatService } from '../../../_services/chat.service';
import 'leaflet-routing-machine';

declare let L;
declare var $: any;

@Component({
  selector: 'app-salidas-material',
  templateUrl: './salidas-material.component.html',
  styleUrls: ['./salidas-material.component.scss']
})
export class SalidasMaterialComponent implements OnInit {

  FORMS: any;
  API: any;
  GENERALES: any;
  PAGE: any;

  idCliente: any;
  idCotizacion: Number;

  sucursal;
  ordenTrabajoId;

  tipoOrden;

  // array´s
  // En el siguiente arrayOrden, lo declaramos como vacío.
  // Porque el DOM se ejecuta primero y da un error en consola.
  /*
  arrayOrden = {
    datosCliente: {
      cliente: [{
        clienteId: ''}
    ],
      contrato: [{
        noContrato: ''}
    ]},
    sucursal: {
      nombreSuc: '',
    },
    flete: {
      vehiculo: [{
        tipo: ''}
    ]}
  };
  */
  arrayOrden = [];
  arrayMaterial = [];
  arrayProductos = [];
  arrayTodoMaterialAlmacen = [];
  arrayProductoXAlmacen = [];
  arrayMaterialATraspaso = [];
  arrayTablaRoja = [];
  arrayCantidadMaterial = [];

  fecha = moment().format('DD-MMM-YYYY');
  // fechaObra;
  fechaObra = moment().format('DD-MMM-YYYY');
  fechaHora;
  fechaYHora;
  hora;
  colchon;

  // Variables
  nombreSucursal;
  nombre;
  apellido;
  nombreCompleto;
  noContrato;
  clienteId;
  obraCotizada;
  referencia;
  telefono;
  celular;
  cantidadTotal;
  vehiculo;
  rentaPeso;
  latitud;
  longitud;
  mapaGoogle;
  sucursalLatitud;
  sucursalLongitud;
  // 0
  formCliente;
  formDescripcion;

  banderaReservado = true;
  banderaObra = true;

  public usuario: Usuario = new Usuario();
  public cliente: Cliente = new Cliente();

  constructor(
    private route: ActivatedRoute,
    private network: NetworkHelperService,
    private ruta: Router,
    private chat: ChatService,
  ) {
    this.FORMS = FORMS;
    this.API = API;
    this.GENERALES = GENERALES;
    this.PAGE = PAGE;
    this.usuario = JSON.parse( localStorage.getItem('usuario') );
    this.idCotizacion = Number(this.route.snapshot.paramMap.get('idOrden'));
    // this.idCliente = Number(this.route.snapshot.paramMap.get('idEntradas'));
    this.ordenTrabajoId = this.route.snapshot.paramMap.get('idOrden');
  }

  ngOnInit() {
    this.sucursal = this.usuario.sucId;
    this.ordenDetalles();
    this.cantidadMaterial();
    // this.listarProductosAlmacenes();
    // this.mapa();
  }

  ordenDetalles() {
    const JSONCOTIID = {
      cotizacionId: this.idCotizacion
    };
    this.network.callSecureService(
      this.API.user.orden + '/' + this.API.user.cotizacion + '/' + this.API.user.detalles,
      'POST',
      JSONCOTIID
    ).subscribe((response: any) => {
      console.log( response );
      if ( response.Estatus === 200 ) {
        this.arrayOrden = response.Mensaje;
        this.tipoOrden = response.Mensaje.ordenOApoyo;
        if ( this.tipoOrden === 'Orden' ) {
          this.colchon = 0;
          console.log( this.colchon );
        } else {
          this.colchon = 5;
          console.log( this.colchon );
        }
        this.arrayProductos = response.Mensaje.material;
        // console.log( this.arrayProductos );
        this.fechaObra = moment(response.Mensaje.fechaObra).locale('es').format('LL');
        this.fechaHora = response.Mensaje.horaObra.split('T')[1];
        this.hora = this.fechaHora.split('-')[0];
        this.fechaYHora = this.fechaObra + ' ' + this.hora;
        // Variables
        this.latitud = response.Mensaje.latitud;
        this.longitud = response.Mensaje.longitud;
        $('#latitudDeSucursal').val(response.Mensaje.sucursal.latlng.latitud);
        $('#longitudDeSucursal').val(response.Mensaje.sucursal.latlng.longitud);
        // this.mapaGoogle = 'https://www.google.com.mx/maps/dir/19.4324523,-99.1761136//@' + this.latitud  + ',' + this.longitud + ',15z';
        if ( this.tipoOrden === 'Orden' ) {
          this.mapaGoogle = 'https://www.google.com.mx/maps/dir/' + response.Mensaje.sucursal.latlng.latitud + ',' + response.Mensaje.sucursal.latlng.longitud + '/' + this.latitud + ',' + this.longitud + '/@' + this.latitud + ',' + this.longitud + ',15z';
        } else {
          this.mapaGoogle = 'https://www.google.com.mx/maps/dir/' + response.Mensaje.miLatitud + ',' + response.Mensaje.miLongitud + '/' + this.latitud + ',' + this.longitud + '/@' + this.latitud + ',' + this.longitud + ',15z';
        }
        this.nombreSucursal = response.Mensaje.sucursal.nombreSuc;
        this.nombre = response.Mensaje.datosCliente.cliente.nombre;
        this.apellido = response.Mensaje.datosCliente.cliente.apellido;
        this.nombreCompleto = this.nombre + ' ' + this.apellido;
        this.noContrato = response.Mensaje.datosCliente.contrato.noContrato;
        this.obraCotizada = response.Mensaje.obraCotizada;
        this.clienteId = response.Mensaje.datosCliente.cliente.clienteId;
        this.referencia = response.Mensaje.referencia;
        this.telefono = response.Mensaje.telefonoCotizado;
        this.celular = response.Mensaje.celularCotizado;
        this.cantidadTotal = response.Mensaje.cantidadTotal;
        this.vehiculo = response.Mensaje.flete.vehiculo.tipo;
        this.rentaPeso = response.Mensaje.rentaPeso;
      } else {
        Swal('Atención', response.Mensaje, 'warning');
      }
      this.todoMaterial();
      // Prueba
      this.listarProductosAlmacenes();
    }, err => {
      console.log(err);
      Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
    });
  }

  // Material para impresion
  todoMaterial() {
    this.network.callSecureService(
      this.API.user.productos,
      'GET',
      null)
      .subscribe((response: any) => {
        for (const recorriendoProducto of response.Mensaje) {
          this.arrayMaterial.push({
            codigo: Number(recorriendoProducto.codigo),
            descrpcion: recorriendoProducto.descrpcion,
            familia: recorriendoProducto.familia,
            cantidad: 0
          });
        }
        // this.dtTrigger.next();
      }, err => {
        console.log(err);
        Swal('Error', this.GENERALES.algoOcurrio, 'error');
      }
    );
  }
  // Material para impresion

  // Productos por almacén
  listarProductosAlmacenes () {
    const JSONALMACEN = {
      sucursalId: this.sucursal
    };
    this.network.callSecureService(
      this.API.user.almacenes + '/' + this.API.user.productos + '/' + this.API.user.almacenes,
      'POST',
      JSONALMACEN
    ).subscribe((response: any) => {
      console.log( response );
      if ( response.Estatus === 201 ) {
        this.arrayTodoMaterialAlmacen = response.Mensaje;
        // For utilizado para recorrer la tabla verde
        for ( const rowProductoAlmacen of this.arrayProductos ) {
          const productoPorCodigo = this.arrayTodoMaterialAlmacen.find( elemento => Number(elemento.producto.codigo) === Number(rowProductoAlmacen.codigo));
          if ( productoPorCodigo ) {
            const diferenciaCantidad = (productoPorCodigo.productoAlmacen.FISICO - this.colchon) - rowProductoAlmacen.cantidad;
            this.arrayProductoXAlmacen.push({
              codigo: productoPorCodigo.producto.codigo,
              descripcion: productoPorCodigo.producto.descripcion,
              almacenFisico: productoPorCodigo.productoAlmacen.FISICO,
              almacenObra: productoPorCodigo.productoAlmacen.OBRA,
              cantidadSolicitada: rowProductoAlmacen.cantidad,
              almacenFisicoFijo: productoPorCodigo.productoAlmacen.FISICO
            });
            if ( diferenciaCantidad < 0 ) {
              this.arrayTablaRoja.push({
                id: rowProductoAlmacen.materialId,
                codigo: productoPorCodigo.producto.codigo,
                descripcion: productoPorCodigo.producto.descripcion,
                cantidadFaltante: diferenciaCantidad * -1
              });
            }
          }
        }
      }
    }, err => {
      console.log(err);
      Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
    });
  }
  // Productos por almacén

  mostrarCantidades( productoXAlmacen ) {
    console.log( productoXAlmacen );
    /*
    productoXAlmacen.almacenFisico = productoXAlmacen.almacenFisicoFijo - productoXAlmacen.cantidadSolicitada;
    if ( productoXAlmacen.almacenFisico <= 0 ) {
      const productoCodigo = this.arrayTablaRoja.find( elemento => Number(elemento.codigo) === Number(productoXAlmacen.codigo));
      if ( productoCodigo.cantidadFaltante <= 0 ) {
        productoCodigo.cantidadFaltante = productoXAlmacen.almacenFisico;
      }
    }
    */
  }

  enReservado() {
    const JSONRESERVADO = {
      ordenTrabajoId: this.ordenTrabajoId
    };
    this.network.callSecureService(
      this.API.user.almacenes + '/' + this.API.user.salidas + '/' + this.API.user.reservado,
      'POST',
      JSONRESERVADO
    ).subscribe((response: any) => {
      console.log( response );
      if ( response.Estatus === 201 ) {
        Swal('Correcto', response.Mensaje, 'success');
      }
    }, err => {
      console.log(err);
      Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
    });
    this.banderaReservado = false;
  }

  enObra() {
    const JSONRESERVADO = {
      ordenTrabajoId: this.ordenTrabajoId
    };
    console.log( JSONRESERVADO );
    /*
    this.network.callSecureService(
      this.API.user.almacenes + '/' + this.API.user.salidas + '/' + this.API.user.obra,
      'POST',
      JSONRESERVADO
    ).subscribe((response: any) => {
      console.log( response );
      if ( response.Estatus === 201 ) {
        Swal('Correcto', response.Mensaje, 'success');
      }
    }, err => {
      console.log(err);
      Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
    });
    this.banderaObra = false;
    */
  }

  // Solicitar Apoyo
  solicitarApoyo () {
    const JSONAPOYOS = {
      ordenTrabajoId: this.ordenTrabajoId,
      material:  this.arrayTablaRoja,
    };
    console.log( JSONAPOYOS );
    this.network.callSecureService(
      this.API.user.almacenes + '/' + this.API.user.salidas + '/' + this.API.user.apoyos,
      'POST',
      JSONAPOYOS
    ).subscribe((response: any) => {
        console.log( response );
        Swal('Correcto', response.Mensaje, 'success');
    }, err => {
        console.log(err);
    });
  }
  // Solicitar Apoyo


  // cantidad de material que aceptaron de mi sucursa1
      
  cantidadMaterial () {
    const JSONORDEN = {
      ordenTrabajoId: this.ordenTrabajoId
    };
    this.network.callSecureService(
      this.API.user.apoyos + '/' + this.API.user.cantidad + '/' + this.API.user.aceptado + '/' + this.API.user.sucursal,
      'POST',
      JSONORDEN
    ).subscribe((response: any) => {
      console.log( response );
      this.arrayCantidadMaterial = response.Mensaje;
    }, err => {
      console.log( err );
    });
  }

  // cantidad de material que aceptaron de mi sucursa1

  // Mover en almacenes para apoyo. De Físico a Reservado
  enReservadoApoyo() {
    const JSONRESERVADO = {
      ordenTrabajoId: this.ordenTrabajoId,
      arrayMaterialesApoyo: this.arrayCantidadMaterial
    };
    console.log( JSONRESERVADO );
    this.network.callSecureService(
      this.API.user.apoyos + '/' + this.API.user.cantidad + '/' + this.API.user.fisico + '/' + this.API.user.reservado,
      'POST',
      JSONRESERVADO
    ).subscribe((response: any) => {
      console.log( response );
      if ( response.Estatus === 201 ) {
        Swal('Correcto', response.Mensaje, 'success');
      }
    }, err => {
      console.log(err);
      Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
    });
    // this.banderaReservado = false;
  }

  // Mover en almacenes para apoyo. De Reservado a Obra
  apoyoDeReservadoSuObra() {
    const JSONRESERVADO = {
      ordenTrabajoId: this.ordenTrabajoId,
      arrayMaterialesApoyo: this.arrayCantidadMaterial
    };
    console.log( JSONRESERVADO );
    this.network.callSecureService(
      this.API.user.apoyos + '/' + this.API.user.cantidad + '/' + this.API.user.reservado + '/' + this.API.user.obra,
      'POST',
      JSONRESERVADO
    ).subscribe((response: any) => {
      console.log( response );
      if ( response.Estatus === 201 ) {
        Swal('Correcto', response.Mensaje, 'success');
      }
    }, err => {
      console.log(err);
      Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
    });
    // this.banderaReservado = false;
  }


  // Impresion Salida de Material
  print(): void {
    for ( const rowProducto of this.arrayProductos ) {
      const productoPorCodigo = this.arrayMaterial.find( elemento => Number(elemento.codigo) === Number(rowProducto.codigo));
      productoPorCodigo.cantidad = Number(rowProducto.cantidad);
      console.log( rowProducto );
    }
    setTimeout(() => {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=70%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title></title>
          <style>
            .letraImprimir {
              font-family: Arial;
              font-weight: lighter;
              font-size: 12px;
            }
            .letraContratacion {
              font-family: Arial;
              font-weight: lighter;
              font-size: 9px;
            }
            .tablaIntegracionGastos{
              border-bottom: 1px solid black;
            }
            .tablas {
              border: 1px solid black;
            }
            .tablaMedida {
              width: 720px;
            }
            .tamagnoCeldas {
              height: 2px;
            }
            #lineaDivisora {
              border-left: 1px solid red;
              margin: 0px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
    }, 1500);
  }

  // Impresión de materiales
  printMateriales(): void {
    // console.log( this.arrayProductos );
    for ( const rowProducto of this.arrayProductos ) {
      const productoPorCodigo = this.arrayMaterial.find( elemento => Number(elemento.codigo) === Number(rowProducto.codigo));
      productoPorCodigo.cantidad = Number(rowProducto.cantidad);
      // console.log( rowProducto );
    }
    setTimeout(() => {
    let printContents, popupWin;
    printContents = document.getElementById('print-section3').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=70%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title></title>
          <style>
            .letraImprimir {
              font-family: Arial;
              font-weight: lighter;
              font-size: 12px;
            }
            .letraContratacion {
              font-family: Arial;
              font-weight: lighter;
              font-size: 9px;
            }
            .tablaIntegracionGastos{
              border-bottom: 1px solid black;
            }
            .tablas {
              border: 1px solid black;
            }
            .tablaMedida {
              width: 720px;
            }
            .tamagnoCeldas {
              height: 2px;
            }
            #lineaDivisora {
              border-left: 1px solid red;
              margin: 0px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
    }, 1500);
  }

  // Impresión Orden de trabajo
  printOrden(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section2').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=70%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title></title>
          <style>
            .letraImprimir {
              font-family: Arial;
              font-weight: lighter;
              font-size: 12px;
            }
            .letraContratacion {
              font-family: Arial;
              font-weight: lighter;
              font-size: 9px;
            }
            .tablaIntegracionGastos{
              border-bottom: 1px solid black;
            }
            .tablas {
              border: 1px solid black;
            }
            .tablaMedida {
              width: 720px;
            }
            .tamagnoCeldas {
              height: 2px;
            }
            #lineaDivisora {
              border-left: 1px solid red;
              margin: 0px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

  // Mapa
  mapa() {
    console.log( this.latitud );
    console.log( this.longitud );
    // console.log( this.sucursalLatitud );
    // console.log( this.sucursalLongitud );
    // declaracion de variables globales en la aplicación de mapa
    var arrayMarcador = [];
    var mapaSelect;
    var mapaRutaPredeterminada;

    // declaracion del mapa
    var map = L.map('map', { /*var map será nuestra variable global y principal, aquí la estamos seteando, asignándole L.map qie es el objeto vacío de la clase Leaflet que estamos llamando y enviándole el “map” que es el ID de nuestro DIV anteriormente creado. */
      dragging: true,
      touchZoom: true,
      scrollWheelZoom: true,
      doubleClickZoom: true,
      boxZoom: true,
      tap: true,
      keyboard: false,
      contextmenu: true,
      contextmenuWidth: 140,
      contextmenuItems: [{
          text: 'Colocar Marcador',
          callback: colocarMarcador
      }, {
        text: 'Remover Marcador',
        callback: removeLayer

      }, {
          text: 'Centrar el mapa aqui',
          callback: centerMap
      }
        , '-', {
          text: 'Zoom +',
          // icon: 'images/zoom-in.png',
          callback: zoomIn
      }, {
          text: 'Zoom -',
         // icon: 'images/zoom-out.png',
          callback: zoomOut
      }
      ],
      fullscreenControl: true,
      fullscreenControlOptions: {
          position: 'topleft'
        }
    }).setView([22.8196273667, -99.9503588558], 5);

    // el tile layer son las capas, en este caso es una capa de mapa(direcciones)
    L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { /*Usamos el servicio como Tile para desplegar el mapa dependiendo del mosaico en pantalla.*/
      maxZoom: 19,
      maxNativeZoom: 19,
      zoomDelta: 0.25,
      zoomSnap: 0,
      attribution: 'Map data &copy; OpenStreetMap contributors' // opciones
    }).addTo(map); // aquí agregamos el mapa base (WMS) a el map (que es nuestra objeto map)

    // es el icono para agregar marcadores
    var myIcon = L.icon({
      iconUrl: '../../../assets/images/marker-icon.png',
      iconSize: [30, 55],
      iconAnchor: [22, 55],
      popupAnchor: [-3, -76],
      shadowUrl: '../../../assets/images/marker-shadow.png',
      shadowSize: [68, 55],
      shadowAnchor: [22, 55]
    });
    // El siguinte modulo es para el buscador, en base a librerias y una API externa es como se buscan las direcciones
    L.Control.geocoder({
      defaultMarkGeocode: false,
      collapsed: false
  })
  .on('markgeocode', function(e) {
      var bbox = e.geocode.bbox;
      var poly = L.polygon([
           bbox.getSouthEast(),
           bbox.getNorthEast(),
           bbox.getNorthWest(),
           bbox.getSouthWest()
      ]);
      map.fitBounds(poly.getBounds());
  }).addTo(map);

  // Como esta es la vista para ver-Cotizador, tendremos que llamar a un metodo instantaneo para poder agregar el marcador que se guardo en ver cotizador
  // primero validaremos si existen la latitud y longitud del mapa
  this.sucursalLatitud = $('#latitudDeSucursal').val();
  this.sucursalLongitud = $('#longitudDeSucursal').val();
  this.latitud = $('#latitud').val();
  this.longitud = $('#longitud').val();

  // entrara en el if si todos poseen la informacion
  if ((this.latitud && this.longitud) && (this.sucursalLongitud && this.sucursalLatitud) ) {
    // Como esto solo existira una vez, llamaremos al metodo directamente
    // Ahora agregaremos el marcador con las cordenadas existentes
    var marker = L.marker([this.latitud, this.longitud], {icon: myIcon}).addTo(map);
    // el marcador solo para el final de la ruta
    // agregaremos la ruta
    mapaRutaPredeterminada = L.Routing.control({
      waypoints: [
        L.latLng(this.latitud, this.longitud),
        L.latLng(this.sucursalLatitud, this.sucursalLongitud)
      ],
      routeWhileDragging: true,
      showAlternatives: false
      }).on('routesfound', function (e) {
        const distance = e.routes[0].summary.totalDistance;
        const min = e.routes[0].summary.totalTime;
        $('#distanciaM').val(distance);
      }).addTo(map);
      mapaRutaPredeterminada.hide();

  }
    // Las siguientes son funciones para el menu de contexto
    // centrar el mapa
    function centerMap (e) {
      map.panTo(e.latlng);
    }
    // colocar el marcador icono
    function colocarMarcador (e) {
      // console.log(mapaRutaPredeterminada);
      if (mapaRutaPredeterminada.length !== 0) {
        mapaRutaPredeterminada.remove();
        mapaRutaPredeterminada = [];
        removeLayer(e);
      }
      if (arrayMarcador.length === 0 || typeof(arrayMarcador.length) === 'undefined') {
        arrayMarcador.push('yes');
      var marker = L.marker(e.latlng, {icon: myIcon}).addTo(map);
      $('#latitud').val(e.latlng.lat);
      $('#longitud').val(e.latlng.lng)

      // Machine route
      this.mapaSelect = L.Routing.control({
        waypoints: [
          L.latLng(e.latlng.lat, e.latlng.lng),
          L.latLng(this.sucursalLatitud, this.sucursalLongitud)
        ],
        routeWhileDragging: true,
        showAlternatives: false
        }).on('routesfound', function (e) {
          const distance = e.routes[0].summary.totalDistance;
          const min = e.routes[0].summary.totalTime;
          $('#distanciaM').val(distance);
        }).addTo(map);
        this.mapaSelect.hide();
      } else {
        // Limpiamos todas las varibales en el mapa
        removeLayer(e);
        arrayMarcador = [];
        this.mapaSelect.remove();
        this.mapaSelect = [];
        // El array marcador es para controlar el flujo al insertar un nuevo marcado de ruta
        arrayMarcador.push('yes');
        var marker = L.marker(e.latlng, {icon: myIcon}).addTo(map);
        this.longitud = e.latlng.lng;
        this.latitud = e.latlng.lat;
        $('#latitud').val(this.latitud);
        $('#longitud').val(this.longitud);

      // Machine route
      this.mapaSelect = L.Routing.control({
        waypoints: [
          L.latLng(this.latitud, this.longitud),
          L.latLng(this.sucursalLatitud, this.sucursalLongitud)
        ],
        routeWhileDragging: true,
        showAlternatives: false
        }).on('routesfound', function (e) {
          const distance = e.routes[0].summary.totalDistance;
          const min = e.routes[0].summary.totalTime;
          $('#distanciaM').val(distance);
          // console.log( distance );
        }).addTo(map);
        this.mapaSelect.hide();
      }
    }
    // Remueve el marcador icono
    function removeLayer(e) {
      map.eachLayer(function(layer) {
        if (layer.dragging) {
          map.removeLayer(layer);
        }
      });
      mapaSelect = [];
    }
    // Le da zoom con click derecho
    function zoomIn (e) {
      map.zoomIn();
    }
    // Quita zoom en dos puntos
    function zoomOut (e) {
      map.zoomOut();
    }
  }
  // Mapa

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/operaciones/salidas-material/salidas-material.component.ts